import _ from "underscore";
import * as actions from "../actions/actionTypes";

const initialState = {
  isFetching: false,
  doc: {},
  error: null
};

const appReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.FETCHING_DOC:
      return _.extend({}, state, { isFetching: true, error: null, doc: {} });
    case actions.FETCHING_DOC_SUCCESS:
      return _.extend({}, state, {
        isFetching: false,
        doc: action.doc,
        error: null
      });
    case actions.FETCHING_DOC_FAILED:
      return _.extend({}, state, {
        isFetching: false,
        doc: {},
        error: action.error
      });
    default:
      return state;
  }
};

export default appReducer;
